// @Version: 1.0.0
import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
   selector: 'app-field-item-divider',
   templateUrl: './divider.component.html',
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         multi: true,
         useExisting: forwardRef(() => FieldItemDividerComponent)
      }
   ],
   standalone: false
})
export class FieldItemDividerComponent implements ControlValueAccessor {

   constructor () { }
   
   writeValue (obj: any): void {}
   registerOnChange (fn: any): void {}
   registerOnTouched (fn: any): void {}
   setDisabledState (isDisabled: boolean | undefined): void {}
}
